import React, { createContext, ReactNode, useContext, useMemo } from "react"
import { useLocation } from "@reach/router"

import { useSmartScriptUrl } from "./useSmartScriptUrl"
import { useUserAgent } from "@/components/hooks/useUserAgent"

interface OneLinkContextValue {
  oneLinkUrl: string
}

const defaultContextValue: OneLinkContextValue = {
  oneLinkUrl: "",
}

const OneLinkContext = createContext<OneLinkContextValue>(defaultContextValue)

export const useSmartScript = () => {
  const context = useContext(OneLinkContext)
  return context
}

interface OneLinkProviderProps {
  children: ReactNode
  pageName: string
  deepLinkValue: string
  afWebDp: string
  defaultURL: string
  oneLinkKey: string
}

export const OneLinkProvider = ({
  children,
  pageName,
  deepLinkValue,
  afWebDp,
  defaultURL,
  oneLinkKey,
}: OneLinkProviderProps) => {
  const location = useLocation()
  const userAgent = useUserAgent()

  const finalAfWebDp = useMemo(() => {
    const baseUrl = afWebDp
    const search = location.search
    if (!search) return baseUrl
    return `${baseUrl}${search}`
  }, [location.search, afWebDp])

  const { oneLinkUrl } = useSmartScriptUrl(oneLinkKey, {
    afWebDp: finalAfWebDp,
    deepLinkValue: deepLinkValue,
    pageName: pageName,
    defaultURL: defaultURL,
  })

  const finalOneLinkUrl =
    userAgent === "ios" || userAgent === "android" ? oneLinkUrl : finalAfWebDp

  return (
    <OneLinkContext.Provider value={{ oneLinkUrl: finalOneLinkUrl }}>
      {children}
    </OneLinkContext.Provider>
  )
}
